export const PARTNER_TYPE = {
  CUSTOMER: "customer",
  SUPPLIER: "supplier",
  BOTH: "both",
} as const;

export const PARTNER_TYPE_LABEL: Record<string, string> = {
  [PARTNER_TYPE.CUSTOMER]: "Khách hàng",
  [PARTNER_TYPE.SUPPLIER]: "Nhà cung cấp",
  [PARTNER_TYPE.BOTH]: "Khách hàng & Nhà cung cấp",
};

export const PARTNER_TYPE_OPTIONS = [
  { value: PARTNER_TYPE.CUSTOMER, label: "Khách hàng" },
  { value: PARTNER_TYPE.SUPPLIER, label: "Nhà cung cấp" },
  { value: PARTNER_TYPE.BOTH, label: "Khách hàng & Nhà cung cấp" },
];
